import React from 'react';
import { Wrapper } from '@magoosh/gre/adaptive_prep_v1/lib/wrapper';
import { PageCard } from '@magoosh/gre/adaptive_prep_v1/lib/page_card';
import { YourClassesProvider } from '@magoosh/pages/live_classes/all_classes/context';
import { YourClasses } from './organisms/upcoming_classes';
import { paths } from 'config/path_helpers';
interface Props {
  descriptionHtml?: string;
}

export const YourClassesPage: React.FC<Props> = (props) => {
  return (
    <Wrapper>
      <PageCard>
        <h2 className="u-margin-A-n">
          <strong>Classes</strong>
        </h2>
        {props.descriptionHtml && <div dangerouslySetInnerHTML={{ __html: props.descriptionHtml }} />}
        <p>
          If you already have a subscription, <a href={paths.login(true)}>click here</a> to sign in.
        </p>
        <YourClassesProvider>
          <YourClasses />
        </YourClassesProvider>
      </PageCard>
    </Wrapper>
  );
};

export default YourClassesPage;
